module.exports = __webpack_public_path__ + "img/08_no.7ced2f6d.svg";